/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as import0 from '@angular/core';
import * as import1 from './cookie-law-element.component.ngfactory';
import * as import2 from 'angular2-cookie-law/lib/cookie-law-element.component';
import * as import3 from '@angular/platform-browser';
import * as import4 from '@angular/common';
import * as import5 from 'angular2-cookie-law/lib/cookie-law.component';
import * as import6 from 'angular2-cookie-law/lib/cookie-law.service';
const styles_CookieLawComponent:any[] = ([] as any[]);
export const RenderType_CookieLawComponent:import0.RendererType2 = import0.ɵcrt({
  encapsulation: 2,
  styles: styles_CookieLawComponent,
  data: {}
}
);
function View_CookieLawComponent_1(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),2,'cookie-law-el',([] as any[]),[[
        2,
        'cookie-law',
        (null as any)
      ]
      ],[[
        (null as any),
        'isSeen'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('isSeen' === en)) {
        const pd_0:any = ((<any>co.hasBeenDismissed()) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },import1.View_CookieLawElementComponent_0,import1.RenderType_CookieLawElementComponent)),
      import0.ɵdid(114688,[[
        1,
        4
      ]
    ],0,import2.CookieLawElementComponent,[import3.DomSanitizer],{
      learnMore: [
        0,
        'learnMore'
      ]
      ,
      target: [
        1,
        'target'
      ]
      ,
      position: [
        2,
        'position'
      ]

    }
    ,{isSeen: 'isSeen'}),
    import0.ɵncd(0,0)
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_1:any = co.learnMore;
    const currVal_2:any = co.target;
    const currVal_3:any = co.position;
    ck(v,1,0,currVal_1,currVal_2,currVal_3);
  },(ck,v) => {
    const currVal_0:any = import0.ɵnov(v,1).cookieLawClass;
    ck(v,0,0,currVal_0);
  });
}
export function View_CookieLawComponent_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    import0.ɵqud(671088640,1,{cookieLawComponent: 0}),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_CookieLawComponent_1)),
    import0.ɵdid(16384,(null as any),0,import4.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n  ']))
  ]
  ,(ck,v) => {
    var co:import5.CookieLawComponent = v.component;
    const currVal_0:boolean = !co.seen;
    ck(v,3,0,currVal_0);
  },(null as any));
}
function View_CookieLawComponent_Host_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'cookie-law',([] as any[]),[[
        1,
        'seen',
        0
      ]
    ],(null as any),(null as any),View_CookieLawComponent_0,RenderType_CookieLawComponent)),
    import0.ɵdid(114688,(null as any),0,import5.CookieLawComponent,[import6.CookieLawService],(null as any),(null as any))
  ]
  ,(ck,v) => {
    ck(v,1,0);
  },(ck,v) => {
    const currVal_0:any = import0.ɵnov(v,1).seen;
    ck(v,0,0,currVal_0);
  });
}
export const CookieLawComponentNgFactory:import0.ComponentFactory<import5.CookieLawComponent> = import0.ɵccf('cookie-law',import5.CookieLawComponent,View_CookieLawComponent_Host_0,{
  name: 'name',
  learnMore: 'learnMore',
  target: 'target',
  position: 'position',
  expiration: 'expiration'
}
,{isSeen: 'isSeen'},['*']);
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL3N0b3JhZ2Uvdmhvc3QvcGFuZWwuZGF0YXNwYWNlLnBsL3dlYi9kYXRhc3BhY2UtY3AtZHMtZnJvbnQvbm9kZV9tb2R1bGVzL2FuZ3VsYXIyLWNvb2tpZS1sYXcvbGliL2Nvb2tpZS1sYXcuY29tcG9uZW50Lm5nZmFjdG9yeS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL3N0b3JhZ2Uvdmhvc3QvcGFuZWwuZGF0YXNwYWNlLnBsL3dlYi9kYXRhc3BhY2UtY3AtZHMtZnJvbnQvbm9kZV9tb2R1bGVzL2FuZ3VsYXIyLWNvb2tpZS1sYXcvbGliL2Nvb2tpZS1sYXcuY29tcG9uZW50LmQudHMiLCJuZzovLy9zdG9yYWdlL3Zob3N0L3BhbmVsLmRhdGFzcGFjZS5wbC93ZWIvZGF0YXNwYWNlLWNwLWRzLWZyb250L25vZGVfbW9kdWxlcy9hbmd1bGFyMi1jb29raWUtbGF3L2xpYi9jb29raWUtbGF3LmNvbXBvbmVudC5kLnRzLkNvb2tpZUxhd0NvbXBvbmVudC5odG1sIiwibmc6Ly8vc3RvcmFnZS92aG9zdC9wYW5lbC5kYXRhc3BhY2UucGwvd2ViL2RhdGFzcGFjZS1jcC1kcy1mcm9udC9ub2RlX21vZHVsZXMvYW5ndWxhcjItY29va2llLWxhdy9saWIvY29va2llLWxhdy5jb21wb25lbnQuZC50cy5Db29raWVMYXdDb21wb25lbnRfSG9zdC5odG1sIl0sInNvdXJjZXNDb250ZW50IjpbIiAiLCJcbiAgICA8Y29va2llLWxhdy1lbCAqbmdJZj1cIiFzZWVuXCJcbiAgICAgICAgICAgICAgICAgICBbbGVhcm5Nb3JlXT1cImxlYXJuTW9yZVwiXG4gICAgICAgICAgICAgICAgICAgW3RhcmdldF09XCJ0YXJnZXRcIlxuICAgICAgICAgICAgICAgICAgIFtwb3NpdGlvbl09XCJwb3NpdGlvblwiXG4gICAgICAgICAgICAgICAgICAgKGlzU2Vlbik9XCJoYXNCZWVuRGlzbWlzc2VkKClcIj48bmctY29udGVudD48L25nLWNvbnRlbnQ+PC9jb29raWUtbGF3LWVsPlxuICAiLCI8Y29va2llLWxhdz48L2Nvb2tpZS1sYXc+Il0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O01DQ0k7UUFBQTtRQUFBO1FBQUE7TUFBQTtNQUFBO1FBQUE7UUFBQTtNQUFBO0lBQUE7TUFBQTtNQUFBO01BSWU7UUFBQTtRQUFBO01BQUE7TUFKZjtJQUFBO2tCQUFBO1FBQUE7UUFBQTtNQUFBO0lBQUE7TUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7TUFBQTs7SUFBQTtLQUFBO2dCQUk2Qzs7OztJQUg5QjtJQUNBO0lBQ0E7SUFIZixTQUNlLFVBQ0EsVUFDQSxTQUhmOztJQUFBO0lBQUEsU0FBQSxTQUFBOzs7Ozs7SUFESjtJQUNJO2dCQUFBOzs7SUFBQTtPQUFBO1FBQUE7UUFBQTtNQUFBO0lBQUE7SUFJc0Y7Ozs7SUFKdkU7SUFBZixTQUFlLFNBQWY7Ozs7O01DREo7UUFBQTtRQUFBO1FBQUE7TUFBQTtJQUFBO2dCQUFBOzs7SUFBQTs7SUFBQTtJQUFBLFNBQUEsU0FBQTs7Ozs7Ozs7OzsifQ==



// WEBPACK FOOTER //
// ./src/$$_gendir/~/angular2-cookie-law/lib/cookie-law.component.ngfactory.ts